export const ArrowUp = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
      <path
        d="M10.2339 2.72526L10.0004 2.49506L9.76639 2.72471L1.74139 10.5997L1.74138 10.5997L1.73915 10.6019C1.53183 10.8092 1.21788 10.8092 1.01056 10.6019C0.803527 10.3949 0.803231 10.0816 1.00967 9.87422C1.00996 9.87392 1.01026 9.87362 1.01056 9.87333L9.63348 1.40039L9.63349 1.40039L9.63556 1.39833C9.84288 1.191 10.1568 1.191 10.3642 1.39833L10.3641 1.39834L10.3662 1.40039L18.9892 9.87333C18.9895 9.87363 18.9898 9.87394 18.9901 9.87425C19.1965 10.0816 19.1962 10.3949 18.9892 10.6019C18.8897 10.7014 18.7458 10.7668 18.6249 10.7668C18.4918 10.7668 18.3788 10.7282 18.2458 10.6249L10.2339 2.72526Z"
        fill="#8899A8"
        stroke="#8899A8"
        strokeWidth="0.666667"
      />
    </svg>
  );
};
